import { FunctionComponent, useState } from 'react';

import { FilterContext, FilterState } from './FilterContext';
import noop from 'utils/noop';

export const PanelFilterContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [fileType, setFileType] = useState<string[]>([]);

  const hasFilters = fileType.length > 0 || searchQuery.trim().length > 0;

  const context: FilterState = {
    fileType,
    setFileType,
    searchQuery,
    setSearchQuery,
    createdByUserId: [],
    setCreatedByUserId: noop,
    updatedByUserId: [],
    setUpdatedByUserId: noop,
    fileSize: [],
    setFileSize: noop,
    clearFilters: noop,
    hasFilters,
  };

  return <FilterContext.Provider value={context}>{children}</FilterContext.Provider>;
};
